<template>
    <div class="area-page">
        <div
            class="area-content"
            v-bind:style="{
                'background-image':
                    'url(' + require('@/assets/megaWish/BG-red@2x.png') + ')'
            }"
        >
            <div class="content-container">
                <div class="content-detail">
                    <div class="topest-img">
                        <img src="@/assets/megaWish/logo2-megawish@2x.png" />
                    </div>
                    <div class="expired-date">{{ lbl.home.rangeDate }}</div>
                    <div class="text-description text-center mt-3">
                        <div class="text-first">
                            {{ lbl.home.titlePrice }}
                        </div>
                        <div class="text-second">
                            {{ lbl.home.titleSumPrice }}
                        </div>
                        <div class="text-last">
                            {{ lbl.home.titlePriceCondition }}
                        </div>
                    </div>
                    <div class="gift-detail">
                        <img src="@/assets/megaWish/aw600x400@2x.png" />
                        <div class="gift-detail-text">
                            <u @click="showModalListGift()">
                                {{ lbl.home.seeDetail }}
                            </u>
                        </div>
                    </div>
                    <div class="contain-claim">
                        <img src="@/assets/megaWish/Text-1@2x.png" />
                        <div class="contain-claim-text">
                            <span>{{ totalDrawCount }}</span>
                            <span class="ml-2">{{ lbl.home.textUnit }}</span>
                        </div>
                    </div>
                    <div class="use-point">
                        <div class="temp-btn">
                            <!-- <img src="@/assets/megaWish/btn-luckydraw@2x.png" /> -->
                            <CustomRedeem
                                :token="token"
                                v-if="isLoaded"
                                :lbl="lbl"
                                :campaign="campaign"
                                :selectedId="campaignId"
                                :selectedPoint="totalDrawCount"
                                :selectedQuantity="1"
                                @afterConfirmLastModal="afterConfirmLastModal"
                                @updateCampaignInfo="updateCampaignInfo($event)"
                            ></CustomRedeem>
                        </div>
                        <div class="use-point-text">
                            *{{ pointPerUnit }} {{ lbl.home.textPriceUnit }}
                        </div>
                    </div>
                    <div class="join-text">
                        <img src="@/assets/megaWish/Howtoplay@2x.png" />
                    </div>
                    <div class="see-gift-detail">
                        <u @click="showModalScrollBody()">
                            {{ lbl.home.otherCondition }}
                        </u>
                    </div>
                    <div class="image-footer">
                        <img src="@/assets/megaWish/footer@2x.png" />
                    </div>
                </div>
            </div>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
        <ErrorModal :lbl="lbl" :busErrorModal="busErrorModal"></ErrorModal>
    </div>
</template>
<script>
import Vue from "vue";
import CustomRedeem from "@/module/Detail/component/detail/CustomRedeem.vue";
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";
import ErrorModal from "@/module/Detail/component/modal/ErrorModal";

import ApiService from "./service/ApiService";
import Locale from "@/helper/locale/locale.js";
import Utility from "@/helper/Utility.js";
import { CampaignConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js";
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign.js";

export default {
    name: "Home",
    components: {
        ModalMaster,
        CustomRedeem,
        ErrorModal
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            modalController: null,
            alertModal: null,
            loadingModal: null,
            scrollBodyModal: null,
            listGiftModal: null,
            totalDrawCount: 0,
            pointPerUnit: null,
            token: null,
            campaignId: null,
            campaign: null,
            isLoaded: false,
            busErrorModal: new Vue()
        };
    },
    created: function() {
        // modal setup
        var modalFactory = new ModalFactory();
        this.modalController = modalFactory.getModalController();
        this.listGiftModal = modalFactory.getListGiftModalController();
        this.scrollBodyModal = modalFactory.getScrollBodyController();
        this.loadingModal = modalFactory.getLoadingModal();
        this.alertModal = modalFactory.getAlertModal();
        this.token = this.$route.query.token || "";
        if (this.token && this.token[0] != ".") {
            this.token = Utility.reShuffleToken(this.token);
        }
        this.getTotalRedemption();
        // this.confirmModal = modalFactory.getConfirmModal();
        // this.otpMoal = modalFactory.getOtpMoal();
    },
    mounted: function() {
        // this.loadingModal.show();
    },
    methods: {
        afterConfirmLastModal: function() {
            this.getTotalRedemption();
        },
        updateCampaignInfo: function() {
            // this.getTotalRedemption();
        },
        getTotalRedemption: async function() {
            this.loadingModal.show();
            try {
                var res = await ApiService.getTotalRedemtion(this.token);
                if (res.data) {
                    var { TotalDrawCount } = res.data;
                    this.totalDrawCount = TotalDrawCount;
                    await this.getCampaign();
                }
                this.loadingModal.hide();
            } catch (ex) {
                this.loadingModal.hide();
                var resEx = ex.response;
                this.alertModal.setTitle(resEx.data.error.message).show();
            }
        },
        getCampaign: async function() {
            var listConfig = {
                config: "campaign_megabangnaapp_draw"
            };
            var res = await ApiService.getCampaign(this.token, listConfig);
            var { data } = res;
            if (data) {
                var campaign = data.shift();
                this.pointPerUnit = campaign.PointPerUnit;
                console.log("this.pointPerUnit", this.pointPerUnit);
                this.campaignId = campaign.ID;
                await this.getCampaignById(this.campaignId);
            }
        },
        getCampaignById: async function(id) {
            var compainConfig = new CampaignConfigBuilder()
                .setCampaignId(id)
                .create();

            var res = await BzbsCampaign.apiGetCampaignDetail(
                this.token,
                compainConfig
            );
            this.isLoaded = true;
            this.campaign = res;
        },
        showModalListGift() {
            this.listGiftModal.show();
        },
        closeModal: function() {
            this.listGiftModal.hide();
        },
        showModalScrollBody: function() {
            this.scrollBodyModal.show();
        },
        closeModalScrollBody: function() {
            this.scrollBodyModal.hide();
        }
    }
};
</script>
<style lang="scss" scoped>
@import "./Home.scss";
</style>
